// Getting started (first-launch walkthrough): whether it has been seen, and a
// way for any screen to open it or to ask the Session tab to build the first
// session once it closes.
const SEEN_KEY = "khronos_setup_seen";
const OPEN_EVENT = "khronos:open-setup";
const START_KEY = "khronos_start_today";

const read = (key, store = localStorage) => {
  try {
    return store.getItem(key);
  } catch {
    return null;
  }
};
const write = (key, value, store = localStorage) => {
  try {
    if (value == null) store.removeItem(key);
    else store.setItem(key, value);
  } catch {
    /* storage disabled: worst case the walkthrough offers itself again */
  }
};

export const hasSeenSetup = () => read(SEEN_KEY) === "1";
export const markSetupSeen = () => write(SEEN_KEY, "1");

export const openSetup = () => window.dispatchEvent(new Event(OPEN_EVENT));
export const onOpenSetup = (handler) => {
  window.addEventListener(OPEN_EVENT, handler);
  return () => window.removeEventListener(OPEN_EVENT, handler);
};

/**
 * One-shot: the Session tab acts on today's suggestion when it next mounts.
 * "start" builds it (end of getting started, Start on the Coach at rest);
 * "customise" opens the generate screen filled in. `overrides` carries the
 * exact shape the Coach showed, so the Session tab can act on it even while
 * another plan is loaded; without it, the empty Session tab works it out.
 */
export const requestStartToday = (action = "start", overrides = null) =>
  write(
    START_KEY,
    JSON.stringify({ action: action === "customise" ? "customise" : "start", overrides }),
    sessionStorage,
  );
export const consumeStartToday = () => {
  const value = read(START_KEY, sessionStorage);
  if (!value) return null;
  write(START_KEY, null, sessionStorage);
  if (value === "1") return { action: "start", overrides: null };
  try {
    const parsed = JSON.parse(value);
    return {
      action: parsed?.action === "customise" ? "customise" : "start",
      overrides: parsed?.overrides || null,
    };
  } catch {
    return null;
  }
};
